<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="illustrations">List of Illustrations</h1>
<p class="toc1"><i>Chapter Two</i></p>
<p class="toc1"><a href="#/10chap2#page17">1. Manuelito</a></p>
<p class="toc1"><a href="#/10chap2#page19">2. Juanita, wife of Manuelito</a></p>
<p class="toc1"><a href="#/10chap2#page35">3. Navaho warrior of the 1860’s</a></p>
<p class="toc1" style="margin-top:20px;"><i>Chapter Three</i></p>
<p class="toc1"><a href="#/11chap3#page41">4. Little Crow</a></p>
<p class="toc1"><a href="#/11chap3#page49">5. Big Eagle</a></p>
<p class="toc1" style="margin-top:20px;"><i>Chapter Four</i></p>
<p class="toc1"><a href="#/12page67#page81">6. Cheyenne and Arapaho Chiefs in Denver</a></p>
<p class="toc1"><a href="#/12page67#page85">7. Little Raven</a></p>
<p class="toc1"><a href="#/12page67#page93">8. George Bent and his wife Magpie</a></p>
<p class="toc1"><a href="#/12page67#page95">9. Edmond Guerrier</a></p>
<p class="toc1" style="margin-top:20px;"><i>Chapter Five</i></p>
<p class="toc1"><a href="#/13chap5#page109">10. Red Cloud</a></p>
<p class="toc1" style="margin-top:20px;"><i>Chapter Six</i></p>
<p class="toc1"><a href="#/14page121#page127">11. Spotted Tail</a></p>
<p class="toc1" style="margin-top:20px;"><i>Chapter Seven</i></p>
<p class="toc1"><a href="#/15chap7#page155">12. Roman Nose</a></p>
<p class="toc1"><a href="#/15chap7#page171">13. Tosawi</a></p>
<p class="toc1" style="margin-top:20px;"><i>Chapter Eight</i></p>
<p class="toc1"><a href="#/16chap8#page181">14. Donehogawa (Ely Parker)</a></p>
<p class="toc1" style="margin-top:20px;"><i>Chapter Nine</i></p>
<p class="toc1"><a href="#/17chap9#page195">15. Cochise</a></p>
<p class="toc1"><a href="#/17chap9#page203">16. Eskiminzin 203</a></p>
<p class="toc1" style="margin-top:20px;"><i>Chapter Ten</i></p>
<p class="toc1"><a href="#/18page219#page223">17. Captain Jack</a></p>
<p class="toc1" id="pagexii" style="margin-top:20px;"><i>Chapter Eleven</i></p>
<p class="toc1"><a href="#/19chap11#page245">18. Satanta</a></p>
<p class="toc1"><a href="#/19chap11#page247">19. Lone Wolf</a></p>
<p class="toc1"><a href="#/19chap11#page251">20. Kicking Bird</a></p>
<p class="toc1"><a href="#/19chap11#page259">21. Ten Bears</a></p>
<p class="toc1"><a href="#/19chap11#page261">22. White Horse</a></p>
<p class="toc1"><a href="#/19chap11#page267">23. Quanah Parker</a></p>
<p class="toc1" style="margin-top:20px;"><i>Chapter Twelve</i></p>
<p class="toc1"><a href="#/20page273#page281">24. Sitting Bull</a></p>
<p class="toc1"><a href="#/20page273#page295">25. Gall</a></p>
<p class="toc1"><a href="#/20page273#page295">26. Two Moon</a></p>
<p class="toc1"><a href="#/20page273#page295">27. Hump</a></p>
<p class="toc1"><a href="#/20page273#page295">28. Crow King</a></p>
<p class="toc1"><a href="#/20page273#page301">29. Young-Man-Afraid-of-His-Horses</a></p>
<p class="toc1"><a href="#/20page273#page309">30. Little Big Man</a></p>
<p class="toc1"><a href="#/20page273#page311">31. Crazy Horse</a></p>
<p class="toc1" style="margin-top:20px;"><i>Chapter Thirteen</i></p>
<p class="toc1"><a href="#/21page315#page319">32. Chief Joseph</a></p>
<p class="toc1" style="margin-top:20px;"><i>Chapter Fourteen</i></p>
<p class="toc1"><a href="#/22chap14#page337">33. Dull Knife</a></p>
<p class="toc1"><a href="#/22chap14#page339">34. Little Wolf</a></p>
<p class="toc1" style="margin-top:20px;"><i>Chapter Fifteen</i></p>
<p class="toc1"><a href="#/23page351#page361">35. Standing Bear</a></p>
<p class="toc1" style="margin-top:20px;"><i>Chapter Sixteen</i></p>
<p class="toc1"><a href="#/24chap16#page369">36. Ouray</a></p>
<p class="toc1"><a href="#/24chap16#page375">37. Nicaagat (Jack)</a></p>
<p class="toc1"><a href="#/24chap16#page383">38. Quinkent (Douglas)</a></p>
<p class="toc1"><a href="#/24chap16#page385">39. Colorow</a></p>
<p class="toc1" style="margin-top:20px;"><i>Chapter Seventeen</i></p>
<p class="toc1"><a href="#/25page391#page395">40. Geronimo</a></p>
<p class="toc1"><a href="#/25page391#page397">41. Naiche and his wife</a></p>
<p class="toc1"><a href="#/25page391#page400">42. Victorio</a></p>
<p class="toc1"><a href="#/25page391#page403">43. Nana</a></p>
<p class="toc1" id="pagexiii" style="margin-top:20px;"><i>Chapter Eighteen</i></p>
<p class="toc1"><a href="#/26page415#page433">44. Wovoka, the Paiute Messiah</a></p>
<p class="toc1"><a href="#/26page415#page433">45. Kicking Bear</a></p>
<p class="toc1"><a href="#/26page415#page433">46. Short Bull</a></p>
<p class="toc1"><a href="#/26page415#page433">47. John Grass</a></p>
<p class="toc1" style="margin-top:20px;"><i>Chapter Nineteen</i></p>
<p class="toc1"><a href="#/27chap19#page443">48. Big Foot in death</a></p>
<p class="toc1"><a href="#/27chap19#page448">49. Red Cloud in old age</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5-illustrations.vue?535db042